import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import "./themes/scss/index.scss";
import "react-notifications/lib/notifications.css";
import "react-toastify/dist/ReactToastify.css";
import ToasterContainer from "./component/Common/ToasterContainer";
import App from "./App";
import "themes/scss/main.scss";
import "../src/index.css";
import TagManager from "react-gtm-module";

ReactDOM.render(
  <Provider store={store}>
    <ToasterContainer />
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (process.env.REACT_APP_ENV === "production") {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
  };
  TagManager.initialize(tagManagerArgs);
}
